import { useEffect } from "react";

import { init, mainButton as mb, secondaryButton as sb } from "@telegram-apps/sdk-react";
import { useAtom } from "jotai";

import { useTranslation } from "@arc/i18n";
import { selectedLanguageAtom } from "@arc/shared/atoms/ui";

import { usePlatformFeature } from "@/hooks/platform";

export const InitTelegramDataListener = () => {
  const { t: _t, i18n } = useTranslation();
  const lp = usePlatformFeature();
  const isTma = lp.usePlatformData().platform === "tma";

  if (isTma) {
    init();
    mb.mount();
    sb.mount();
  }

  const [language, setLanguage] = useAtom(selectedLanguageAtom);

  useEffect(() => {
    if (isTma) {
      mb.setParams({ isVisible: false });
      sb.setParams({ isVisible: false });
    }
  }, []);

  useEffect(() => {
    if (isTma) {
      mb.setParams({
        backgroundColor: "#07ACFF",
        textColor: "#FFFFFF",
      });
      sb.setParams({
        backgroundColor: "#d9e4ff",
        textColor: "#07ACFF",
      });
    }
  }, []);

  useEffect(() => {
    const userLanguage = language || lp.useTelegramData().initData?.user?.language_code;
    if (userLanguage) {
      i18n.languages.forEach((lang) => {
        if (userLanguage === lang) {
          i18n.reloadResources([lang]).then(() => i18n.changeLanguage(lang));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!i18n.isInitialized) return;

    i18n.on("languageChanged", (lang) => {
      document.documentElement.setAttribute("lang", lang);
      setLanguage(i18n.language);
    });

    return () => {
      i18n.off("languageChanged");
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.isInitialized]);

  return null;
};
